import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

const WhatsAppIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.129 6.744 3.047 9.379L1.054 31.49l6.311-2.024A15.89 15.89 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0Zm9.335 22.594c-.39 1.1-1.932 2.014-3.168 2.28-.846.18-1.95.323-5.668-1.218-4.76-1.972-7.822-6.795-8.06-7.11-.228-.315-1.916-2.553-1.916-4.867 0-2.315 1.213-3.452 1.643-3.924.39-.428 1.022-.624 1.627-.624.196 0 .372.01.53.018.47.02.706.048 1.017.789.39.928 1.34 3.272 1.457 3.51.12.238.238.554.077.87-.15.323-.283.467-.52.74-.239.273-.465.482-.703.775-.218.258-.463.534-.193 1.004.27.46 1.2 1.98 2.576 3.208 1.768 1.58 3.258 2.07 3.722 2.298.39.19.854.152 1.133-.152.352-.39.787-.923 1.23-1.448.315-.375.713-.42 1.143-.252.435.16 2.762 1.303 3.233 1.54.47.239.784.354.9.553.114.2.114 1.142-.277 2.242Z"/>
  </svg>
);
import { useScrollReveal } from "@/hooks/use-scroll-reveal";

export function FinalCTA() {
  const { ref, isVisible } = useScrollReveal();
  const whatsappNumber = "27732509394";
  const message = encodeURIComponent("Hi Bookkeeping Services SA, I'd like to book a free consultation to discuss bookkeeping and SARS compliance for my business.");

  return (
    <section className="py-20 lg:py-28 bg-gradient-animated relative overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }} />
      </div>
      
      <div
        ref={ref}
        className={`container mx-auto px-4 relative z-10 scroll-reveal ${isVisible ? "revealed" : ""}`}
      >
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6">
            Ready to Get Your Books Handled Properly?
          </h2>
          <p className="text-xl text-primary-foreground/80 mb-10">
            Let us take care of your bookkeeping, compliance, and peace of mind. 
            Get started with a free consultation today.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/book-a-call">
              <Button 
                size="lg" 
                className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 gap-2 text-base px-8 h-14 btn-shimmer"
              >
                <Phone className="w-5 h-5" />
                Book a Call
              </Button>
            </Link>
            <a 
              href={`https://wa.me/${whatsappNumber}?text=${message}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-primary-foreground text-primary-foreground bg-transparent hover:bg-primary-foreground hover:text-primary gap-2 text-base px-8 h-14"
              >
                <WhatsAppIcon className="w-5 h-5" />
                WhatsApp Us
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
